var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass: "quick-replies-popup px-4 py-2",
          attrs: { "data-test": "quick-replies-popup" }
        },
        [
          _c(
            "div",
            { staticClass: "quick-replies-header d-flex align-center pa-2" },
            [
              _c("icon-svg", {
                staticClass: "mr-2",
                attrs: {
                  name: "mdi-lightning-bolt",
                  size: "16",
                  color: "primary"
                }
              }),
              _c(
                "span",
                {
                  staticClass:
                    "az-text-primary az-size-14 font-medium flex-grow-1"
                },
                [_vm._v(" Respostas rápidas ")]
              ),
              _c(
                "BaseButton",
                {
                  staticClass: "mr-1",
                  attrs: {
                    primary: "",
                    small: "",
                    "fit-content": "",
                    "min-width": "auto",
                    "data-test": "gerenciar-btn"
                  },
                  on: { click: _vm.onGerenciar }
                },
                [_vm._v(" Gerenciar ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    icon: "",
                    small: "",
                    "data-test": "quick-replies-close",
                    "aria-label": "Fechar respostas rápidas"
                  },
                  on: { click: _vm.onClose }
                },
                [_c("icon-svg", { attrs: { name: "close", size: "16" } })],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "quick-replies-search pa-2" },
            [
              _c("input-by-type", {
                attrs: {
                  type: "text",
                  outlined: "",
                  dense: "",
                  "hide-details": "",
                  "data-test": "quick-reply-search",
                  placeholder: "Buscar resposta..."
                },
                model: {
                  value: _vm.searchText,
                  callback: function($$v) {
                    _vm.searchText = $$v
                  },
                  expression: "searchText"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "quick-replies-list" },
            [
              _vm._l(_vm.filteredReplies, function(reply) {
                return _c(
                  "div",
                  {
                    key: reply.id,
                    staticClass: "quick-reply-item d-flex align-center pa-2",
                    attrs: { "data-test": "quick-reply-item" },
                    on: {
                      click: function($event) {
                        return _vm.selectReply(reply)
                      }
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "az-text-primary az-size-14 font-medium mr-2 text-truncate quick-reply-item__titulo"
                      },
                      [_vm._v(" " + _vm._s(reply.titulo) + " ")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass:
                          "az-text-secondary az-size-12 text-truncate quick-reply-item__conteudo flex-grow-1"
                      },
                      [_vm._v(" " + _vm._s(reply.conteudo) + " ")]
                    )
                  ]
                )
              }),
              !_vm.hasReplies
                ? _c(
                    "div",
                    {
                      staticClass:
                        "az-text-secondary az-size-12 text-center pa-3",
                      attrs: { "data-test": "no-replies" }
                    },
                    [_vm._v(" Nenhuma resposta encontrada ")]
                  )
                : _vm._e()
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }